import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3ijfvu1ti80fo">
      <MetaPixel data-id="element-1" data-mp="3mjq45l4rr2xp" />
      <main data-id="element-2" data-mp="3mj6jhwnqi0fz">
        <Hero data-id="element-3" data-mp="3rcj6y3gog175" />
        <SocialProofBar data-id="element-4" data-mp="3rbrcwx2qabiz" />
        <PainGrid data-id="element-5" data-mp="3rdkh85pvcjnt" />
        <ProductReveal data-id="element-6" data-mp="3rd18nfm3z7mg" />
        <LookInside data-id="element-7" data-mp="5yj0slx59ec" />
        <Tomes data-id="element-8" data-mp="6hq1ea16ddl" />
        <Bonuses data-id="element-9" data-mp="4wxfu7a14id" />
        <ValueStack data-id="element-10" data-mp="5ggje8nxyxz" />
        <Urgency data-id="element-11" data-mp="82j0zgp5o9c" />
        <Pricing data-id="element-12" data-mp="2zl3cjn8vpa6d" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-13" data-mp="2zlld2w2kqak3" />
        <Guarantee data-id="element-14" data-mp="33mow1rfx4mpj" />
        <Faq data-id="element-15" data-mp="33m5c656pjo8v" />
        <Testimonials testimonials={moreTestimonials} title="More coaches, more seasons" background="cream" data-id="element-16" data-mp="33nq73vwxp979" />
        <CostOfInaction data-id="element-17" data-mp="38o4fxg6d0n6c" />
        <Close data-id="element-18" data-mp="3dkl0k0ecojeo" />
      </main>
      <Footer data-id="element-19" data-mp="3dlwa6guh8ldp" />
      <PurchaseNotifications data-id="element-20" data-mp="3dmfo7mh0apmg" />
    </div>;
}